import "./utils/landingMarket.js";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
// import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import store from "./reduxdata/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { messaging } from "./firebase";
//STRIPE
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import TagManager from "react-gtm-module";
import "./i18n";
import { initMixpanel } from "./utils/mixpanel";
import { useTranslation } from "react-i18next";
import AppLoadingScreen from "./AppLoadingScreen";

// Uncomment to hide console errors/warnings
// console.error = console.warn = () => { };

const LoadingSpinner = React.lazy(() => import("./LoadingSpinner"));
const LazyApp = React.lazy(() => import("./App"));

const REACT_GTM_ID = import.meta.env.VITE_GTM_ID;
const REACT_APP_STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
// console.log('Stripe Key exists:', !!REACT_APP_STRIPE_PUBLISHABLE_KEY);
// Load Stripe with your publishable key - only if key exists
const stripePromise = REACT_APP_STRIPE_PUBLISHABLE_KEY
  ? loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY)
  : null;

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('/firebase-messaging-sw.js')
//     .then((registration) => {
//       console.log('Service worker registered:', registration);
//     })
//     .catch((err) => {
//       console.error('Service worker registration failed:', err);
//     });
// }
const tagManagerArgs = {
  gtmId: REACT_GTM_ID,
};

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      //console.log("Service Worker registered with scope:", registration.scope);
      // Note: messaging.useServiceWorker is not available in Firebase v9+ modular SDK
      // The service worker registration is sufficient for background messaging
    })
    .catch((err) => {
      //   console.warn("Service Worker registration failed (this is okay if you don't need push notifications):", err);
    });
}
TagManager.initialize(tagManagerArgs);
const root = ReactDOM.createRoot(document.getElementById("root"));

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
// console.log('Google Client ID exists:', !!googleClientId);

// Error boundary for lazy loading
const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const errorHandler = (event) => {
      //   console.error('Uncaught error:', event.error);
      setError(event.error);
      setHasError(true);
    };

    window.addEventListener("error", errorHandler);
    window.addEventListener("unhandledrejection", (event) => {
      //   console.error('Unhandled promise rejection:', event.reason);
      setError(event.reason);
      setHasError(true);
    });

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  if (hasError) {
    return (
      <div
        style={{ padding: "20px", fontFamily: "Arial", textAlign: "center" }}
      >
        <h1 style={{ color: "red" }}>Application Error</h1>
        <p>
          There was an error loading the application. Please check the browser
          console for details.
        </p>
        {error && (
          <pre
            style={{
              background: "#f0f0f0",
              padding: "10px",
              borderRadius: "5px",
              textAlign: "left",
              overflow: "auto",
            }}
          >
            {error.toString()}
            {error.stack && "\n\n" + error.stack}
          </pre>
        )}
        <button
          onClick={() => window.location.reload()}
          style={{ marginTop: "20px", padding: "10px 20px" }}
        >
          Reload Page
        </button>
      </div>
    );
  }

  return children;
};

// App wrapper component that handles Stripe
const AppWrapper = () => {
  const { i18n } = useTranslation();

  if (!stripePromise) {
    return <LazyApp />;
  }

  const stripeLocale = i18n.language === "ar" ? "ar" : "en";

  return (
    <Elements
      stripe={stripePromise}
      options={{
        locale: stripeLocale,
      }}
    >
      <LazyApp />
    </Elements>
  );
};

initMixpanel();

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <GoogleOAuthProvider clientId={googleClientId}>
      <Suspense fallback={<AppLoadingScreen />}>
        <AppWrapper />
        {/* <AppLoadingScreen /> */}
      </Suspense>
    </GoogleOAuthProvider>
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
